import styled from 'styled-components';
import { cssVars } from '../../shared/lib/styledTheme';

export const ProfileMenuContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;
`;

export const ProfileButton = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s;
  position: relative;

  &:hover {
    background-color: ${cssVars.hover};
  }
`;

export const ProfileAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background-color: ${cssVars.bgSecondary};
  border: 2px solid ${cssVars.borderColor};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProfileAvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProfileAvatarPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
`;

export const ProfileLabel = styled.span`
  font-size: 14px;
  color: ${cssVars.textPrimary};
  font-weight: 500;
`;

export const DropdownMenu = styled.div`
  position: fixed;
  background-color: ${cssVars.bgColor};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  overflow: hidden;
  min-width: 150px;
  width: max-content;
`;

export const DropdownMenuItem = styled.button`
  display: block;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  text-align: left;
  font-size: 14px;
  color: ${cssVars.textPrimary};
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${cssVars.borderColor};
  }
`;

